import {
  Body,
  Caption,
  Flex,
  LazyImage,
  Loading,
  Modal,
  ModalBody,
  Shape,
  Title,
  styled,
} from '@teko/ds-desktop';
import { ProductCarousel } from '@teko/teko-ecommerce';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { isServerless } from 'helpers';
import { useSearch, useTenantConfig } from 'hooks';
import { t } from 'i18n';
import { IRelatedProductParams } from 'types';

interface RelatedProductsModalProps {
  productInfo: IRelatedProductParams;
  onCloseModal?: () => void;
}

export const RelatedProductsModal: React.FC<RelatedProductsModalProps> = ({
  productInfo,
  onCloseModal,
}) => {
  const { passSkuToReturnSimilarProducts } = useTenantConfig();
  const { sku, imageUrl, name, categoryId } = productInfo;

  const searchRelatedProductsParams =
    !!sku && passSkuToReturnSimilarProducts
      ? {
          page: 1,
          pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
          filter: {
            skuToReturnSimilarProducts: sku,
          },
        }
      : !!categoryId && !!sku
      ? {
          page: 1,
          pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
          filter: {
            excludedSkus: [sku],
            categoryIds: [categoryId],
          },
        }
      : {};

  const { result: searchRelatedProductsResult, isLoading } = useSearch(
    searchRelatedProductsParams,
  );

  return (
    <Modal
      visible={!!sku}
      title={
        <Title level={3} paddingLeft="s16" paddingTop="s20">
          {t('Sản phẩm tương tự')}
        </Title>
      }
      onClose={onCloseModal}
      footer={null}
      width={'70%'}
      zIndex={1051}
      contentStyle={{ padding: 0 }}
    >
      <ModalBody padding={['s0', 's0']}>
        <Loading isLoading={isLoading}>
          <StyledShape>
            <Flex
              backgroundColor="white"
              padding="s8"
              borderRadius="m"
              align="center"
              gap="s8"
            >
              {imageUrl && (
                <LazyImage width="32px" height="32px" src={imageUrl} />
              )}
              <Caption level={1}>{name}</Caption>
            </Flex>
            {!!searchRelatedProductsResult.products.length ? (
              <>
                <Body level={1} marginTop="s16" marginBottom="s16">
                  {t('Tìm thấy')}{' '}
                  <strong>{`${searchRelatedProductsResult.products.length} `}</strong>
                  {t('Sản phẩm tương tự')}
                </Body>
                <ProductCarousel
                  products={searchRelatedProductsResult.products}
                  productsPerRow={5}
                  regionName="relatedProducts"
                  virtual={isServerless()}
                />
              </>
            ) : null}
          </StyledShape>
        </Loading>
      </ModalBody>
    </Modal>
  );
};

const StyledShape = styled(Shape)`
  background: #f5f5f5;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 8px 16px;
`;
